import { createAsyncThunk } from "@reduxjs/toolkit";
import { USERAXIOS } from "api";
import responseError from "utils/api/error-handling";
import reportURL from "../../../../utils/url/basicInfo/reporet";

//get AllUser
export const getAllReport = createAsyncThunk(
  "basicInfo/getAllReport",
  async ({ pageNumber }: { pageNumber: number }, thunkAPI) => {
    try {
      const response = await USERAXIOS.get(
        `${reportURL.GET_ALL_REPORTS}?page=${pageNumber}`,
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(responseError(error));
    }
  },
);
export const searshAllReport = createAsyncThunk(
  "basicInfo/searshAllReport",
  async ({ text_trans  }: { text_trans: string }, thunkAPI) => {
    try {
      const response = await USERAXIOS.get(
        `${reportURL.GET_ALL_REPORTS}?text_trans=${text_trans}`,
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(responseError(error));
    }
  },
);
//GET ONE USER

export const getOneReport = createAsyncThunk(
  "basicInfo/getOneReport",
  async ({ id }: { id: string }, thunkAPI) => {
    try {
      const response = await USERAXIOS.get(`${reportURL.GET_ONE_REPORT}${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(responseError(error));
    }
  },
);

//EDIT ONE USER

export const editReport = createAsyncThunk(
  "basicInfo/editReport",
  async ({ id, data }: { id: any; data: any }, thunkAPI) => {
    try {
      const response = await USERAXIOS.post(
        `${reportURL.EDIT_REPORT}${id}`,
        data,
      );
      return response.data.result;
    } catch (error) {
      return thunkAPI.rejectWithValue(responseError(error));
    }
  },
);
export const addReport = createAsyncThunk(
  "basicInfo/addReport",
  async (data: any, thunkAPI) => {
    try {
      const response = await USERAXIOS.post(reportURL.ADD_REPORT, data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(responseError(error));
    }
  },
);

export const deleteReport = createAsyncThunk(
  "basicInfo/deleteReport",
  async ({ id }: { id: number }, thunkAPI) => {
    try {
      const response = await USERAXIOS.delete(
        `${reportURL.DELETE_REPORT}${id}`,
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(responseError(error));
    }
  },
);

export const MultiDeletReport = createAsyncThunk(
  "basicInfo/MultiDeletReport",
  async ({ ids }: { ids: number[] }, thunkAPI) => {
    try {
      const response = await USERAXIOS.delete(reportURL.MULTI_DELET_REPORTS, {
        data: { ids },
      });
      console.log(response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(responseError(error));
    }
  },
);
